// extracted by mini-css-extract-plugin
module.exports = {"inputSection":"tagsForm_inputSection__PIU1e","selection":"tagsForm_selection__HJ_Ws","errorMessage":"tagsForm_errorMessage__vz6cv"};